// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vdc-trans-group-container{display:flex;flex-wrap:inherit;-ms-flex-wrap:inherit}.vdc-out-container{display:flex;flex-wrap:wrap;-ms-flex-wrap:wrap}.vdc-item-container:hover{box-shadow:0 2px 2px 2px rgba(0,0,0,.1);border-radius:10px}.fade-enter-active,.fade-leave-active,.fade-move{transition:all .5s cubic-bezier(.55,0,.1,1)}.fade-enter-from,.fade-leave-to{opacity:0;transform:scaleY(.01) translate(30px)}.fade-leave-active{position:absolute}", ""]);
// Exports
module.exports = exports;
